export default "__VITE_ASSET__d50c9f19__"